import React, { useEffect, useMemo, useState } from "react";
import Axios from "axios";
import base from "../../config";
import "./custom.css";
import 'react-toastify/dist/ReactToastify.css'
import {
    CircularProgress,
    Tab,
    InputAdornment,
    TextField,
    IconButton,
} from "@material-ui/core/";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import { ToastContainer, toast } from 'react-toastify';
import { PrimaryButton } from "../common/CommonComponents/Buttons";
import { CommonDialog } from "../common/CommonComponents/Dialog";
import { StyledPaper, StyledTabs } from '../fui/FuiStyles'
import AccessCards from "./AccessCards";
import BedrockAccessCards from "./BedrockAccessCards";
import RequestForm from "./RequestForm";
import Requests from "./Requests";
import { Footer } from "../common/Footer";

/**
   * @author shilpa.adikeshava
   * @version 1.0
 */

const AzureOpenAI = () => {

    const idToken = localStorage.getItem("token");
    const [loading, setLoading] = useState(true);
    const [accessData, setAccessData] = useState([]);
    const [pdfFileUrl, setPdfFileUrl] = useState("");
    const [pptFileUrl, setPptFileUrl] = useState("");
    const [requestData, setRequestData] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");

    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        setOpen(false);
    };

    const options = {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: idToken,
        },
    };

    useEffect(() => {
        getOpenAIAccessDataOnLoad();
        // getOpenAIRequestsOnLoad();
        getDocLinks();
        const interval = setInterval(() => {
            // getOpenAIRequests();
            getOpenAIAccessData();
        }, 20000);
        return () => clearInterval(interval);
    }, []);

    const getOpenAIAccessDataOnLoad = () => {
        const urls = `${base.urls.apis.azure}/openai-access/read/all?inititive=na`;
        Axios.get(urls, options).then((res) => {
            const data = res.data
            setAccessData(data)
            // setLoading(false)
        }).catch((error) => {
            console.log('Error', error)
        })
    }

    const getOpenAIAccessData = () => {
        const urls = `${base.urls.apis.azure}/openai-access/read/all?inititive=na`;
        Axios.get(urls, options).then((res) => {
            const data = res.data
            setAccessData(data)
            setLoading(false)
        }).catch((error) => {
            console.log('Error', error)
        })
    }

    const getOpenAIRequests = () => {
        const urls = `${base.urls.apis.azure}/addopenai/read/all?inititive=na`;
        Axios.get(urls, options).then((res) => {
            const data = res.data
            setRequestData(data)
            setLoading(false)
        }).catch((error) => {
            console.log(error)
        })
    }

    const getOpenAIRequestsOnLoad = () => {
        const urls = `${base.urls.apis.azure}/addopenai/read/all?inititive=na`;
        Axios.get(urls, options).then((res) => {
            const data = res.data
            setRequestData(data)
            setLoading(false)
        }).catch((error) => {
            console.log(error)
        })
    }

    const getDocLinks = () => {
        const urls = `${base.urls.apis.azure}/openai-access?inititive=na`;
        Axios.get(urls, options).then((res) => {
            const data = res.data
            setPdfFileUrl(data[0].genai_wkshp_pdf)
            setPptFileUrl(data[0].hipaa_ppt)
        }).catch((error) => {
            console.log('Error', error)
        })
    }

    // Reset the shared search whenever the tab changes, so switching from
    // Azure OpenAI to Bedrock doesn't carry over a filter that means
    // something different in the new context.
    const handleTabChangeAndResetSearch = (event, newValue) => {
        setTabIndex(newValue);
        setSearchQuery("");
    };

    const searchPlaceholder = useMemo(
        () =>
            tabIndex === 0
                ? "Search Azure OpenAI deployments by cluster, region, status, enterprise ID…"
                : "Search Bedrock deployments by client, model, region, status…",
        [tabIndex]
    );

    return (
        <>
            <div className="llm-root">
                <div className="llm-tab-bar-wrap">
                    <StyledTabs
                        value={tabIndex}
                        onChange={handleTabChangeAndResetSearch}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        className="llm-tabs"
                        margin="0px"
                    >
                        <Tab label="Azure OpenAI" data-cy="openAiTab" className="llm-tab" />
                       {/* <Tab label="Bedrock" data-cy="bedrockTab" className="llm-tab" /> */}
                    </StyledTabs>
                </div>

                <div className="llm-search-bar">
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        className="llm-search-input"
                        placeholder={searchPlaceholder}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon style={{ color: "#9a9ca3" }} />
                                </InputAdornment>
                            ),
                            endAdornment: searchQuery ? (
                                <InputAdornment position="end">
                                    <IconButton size="small" onClick={() => setSearchQuery("")} aria-label="Clear search">
                                        <ClearIcon fontSize="small" style={{ color: "#9a9ca3" }} />
                                    </IconButton>
                                </InputAdornment>
                            ) : null,
                        }}
                    />
                </div>

                {tabIndex === 0 && (
                    loading ? (
                        <div
                            style={{
                                marginTop: "15%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <CircularProgress size={40} />
                        </div>
                    ) : (
                        <div>
                             
                            <ToastContainer autoClose={2000} />
                            {accessData && accessData.length > 0 && (
                                <div className="llm-section-heading">
                                    <span className="llm-section-heading-bar"></span>
                                    <h2 className="llm-section-heading-text">Your Active LLMs</h2>
                                </div>
                            )}
                            <AccessCards data={accessData} searchQuery={searchQuery} />
                        </div>
                    )
                )}

                {tabIndex === 1 && (
                    <div>
                        <div className="llm-section-heading">
                            <span className="llm-section-heading-bar"></span>
                            <h2 className="llm-section-heading-text">Your Active LLMs</h2>
                        </div>
                        <BedrockAccessCards searchQuery={searchQuery} />
                    </div>
                )}
                <CommonDialog
                    className="AzureOpenAIDialog"
                    open={open}
                    onClose={handleClose}
                    title={"Request for LLM Access"}
                    dialogType={"fui"}
                    dialogContent={< RequestForm pdfFileUrl={pdfFileUrl} pptFileUrl={pptFileUrl} close={handleClose} />}
                    dialogSize={"full"}
                ></CommonDialog>
            </div>

            <Footer />
        </>
    );
};

export default AzureOpenAI;
